import {ButtonContainer} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import React from "react";

export default function ButtonWithLoader ({loading,text = '', width = '',reverse = false,onClick }) {
    return <ButtonContainer width={width} disabled={loading}  reverse={reverse} onClick={() => !loading && onClick()}>
        {
            ( loading) ?  <ClipLoader
                    size={24}
                    color={`#c15510`}
                /> :
                text}
    </ButtonContainer>
}